import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './ReasonsView.css';
import { Loader } from 'semantic-ui-react';
import RadioGroup from '../RadioGroup';
import NoReasonsFound from '../NoReasonsFound';

export default class ReasonsView extends React.Component {

  get content() {
    const { hasFetched, appointmentReasons, value, onReasonSelected, serviceName } = this.props;
    if ( appointmentReasons && appointmentReasons.length > 0 ) {
      return (
        <RadioGroup
          name="service-reason-radio"
          options={appointmentReasons}
          value={value}
          onSelectOption={onReasonSelected}
        />
      );
    }
    if ( !hasFetched ) return <div><Loader active inline='centered'>Loading reasons...</Loader></div>;
    return <NoReasonsFound name={serviceName} />;
  }

  render() {
    return (
      <div className={css['content']}>
        <div>What do you need help with?</div>
        {this.content}
      </div>
    );
  }
}

ReasonsView.propTypes = {
  appointmentReasons: PropTypes.array,
  hasFetched: PropTypes.bool.isRequired,
  value: SFEntityID,
  onReasonSelected: PropTypes.func.isRequired,
  serviceName: PropTypes.string.isRequired
};
